export default __webpack_public_path__ + "static/media/1@5mm_bag.e10c8123.jpg";